import React from "react";
import { Skeleton } from "@mui/material";

import { StyledTable } from "./styledTable";

const PaymentTableComponent = (props) => {
  const {
    isLoadingCartPrice,
    totalRawPrice,
    finalDiscountPrice,
    paymentMethod,
    walletBalanceData,
    totalTax,
    priceAfterPayWithWallet,
    totalPrice,
  } = props;

  const tableData = [
    { id: 1, title: "قیمت", content: totalRawPrice, className: "price-td" },
    {
      id: 2,
      title: "تخفیف",
      content: finalDiscountPrice,
      className: "discount-td",
    },
    {
      id: 3,
      title: "کسر از کیف پول",
      content: walletBalanceData,
      trclassName: `wallet-information ${
        paymentMethod ? "fade-in" : "fade-out"
      }`,
      className: "discount-td",
    },
    { id: 4, title: "مالیات", content: totalTax, className: "tax-td" },
    {
      id: 5,
      title: "قابل پرداخت",
      content: paymentMethod ? priceAfterPayWithWallet : totalPrice,
      className: "tax-td",
    },
  ];
  return (
    <StyledTable className="mx-auto">
      <tbody>
        {tableData.map((item) => (
          <tr className={item.trclassName} key={item.id}>
            <td>{item.title}</td>
            <td className={item.className}>
              {isLoadingCartPrice ? (
                <Skeleton width={80} />
              ) : (
                <>{item.content}</>
              )}
            </td>
            <td>&nbsp;&nbsp;تومان</td>
          </tr>
        ))}
      </tbody>
    </StyledTable>
  );
};

export default PaymentTableComponent;
